var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIconSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 31,
    rx: 5.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 31,
    rx: 5.5,
    stroke: "#CCCCCC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6476 7.20895C17.8428 7.01368 18.1594 7.01368 18.3547 7.20895L22.1047 10.9589C22.3 11.1542 22.3 11.4708 22.1047 11.6661C21.9094 11.8613 21.5928 11.8613 21.3976 11.6661L18.501 8.76944V16.9375C18.501 17.2136 18.2771 17.4375 18.001 17.4375C17.7248 17.4375 17.501 17.2136 17.501 16.9375V8.76977L14.6047 11.6661C14.4094 11.8613 14.0928 11.8613 13.8976 11.6661C13.7023 11.4708 13.7023 11.1542 13.8976 10.9589L17.6476 7.20895ZM11.4385 15.4583C11.1969 15.4583 11.001 15.6542 11.001 15.8958V23.5C11.001 23.7416 11.1969 23.9375 11.4385 23.9375H24.5635C24.8051 23.9375 25.001 23.7416 25.001 23.5V15.8958C25.001 15.6542 24.8051 15.4583 24.5635 15.4583H22.6885C22.4123 15.4583 22.1885 15.2345 22.1885 14.9583C22.1885 14.6822 22.4123 14.4583 22.6885 14.4583H24.5635C25.3574 14.4583 26.001 15.1019 26.001 15.8958V23.5C26.001 24.2939 25.3574 24.9375 24.5635 24.9375H11.4385C10.6446 24.9375 10.001 24.2939 10.001 23.5V15.8958C10.001 15.1019 10.6446 14.4583 11.4385 14.4583H13.3135C13.5896 14.4583 13.8135 14.6822 13.8135 14.9583C13.8135 15.2345 13.5896 15.4583 13.3135 15.4583H11.4385Z",
    fill: "#101010"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIconSmall);
export default __webpack_public_path__ + "static/media/share-icon-small.1b904ae069c32265ef63a8a49ec098c4.svg";
export { ForwardRef as ReactComponent };